<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 style="color: #101010;line-height: 31px;" class="mb-0">
        {{ $l('table_label_all_permission_role') || '全部权限角色' }}
      </h6>
    </div>

    <vxe-grid
      ref="table"
      size="mini"
      border
      resizable
      auto-resize
      row-id="roleID"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        trigger: 'row',
        checkRowKeys: checkRowKeys,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: { userCode: { type: String, default: '' } },
  data() {
    return {
      searchKey: '',
      tableData: [],
      checkRowKeys: [],
      loading: false,
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          title: this.$l('table_label_roleName') || '角色名称',
          field: 'roleName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
        },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    height() {
      const height = this.tableHeight - 250
      return height < 500 ? 500 : height
    },
  },
  methods: {
    query() {
      this.getData()
    },
    async getData() {
      this.checkRowKeys = []
      this.loading = true
      const res = await this.$api
        .sysUserRoleListApi({
          userCode: this.userCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      const { data } = res.body
      this.tableData = data
      data.forEach((item) => {
        if (item.permission === 'Y') this.checkRowKeys.push(item.roleID)
      })
    },
    checkboxChange({ records }) {
      this.$emit('checkboxChange', records)
    },
    cancelCheck(roleIds) {
      roleIds.forEach((id) => {
        const row = this.$refs.table.getRowById(id)
        this.$refs.table.setCheckboxRow(row, false)
      })
    },
    getTableData() {
      return this.$refs.table.getCheckboxRecords()
    },
  },
}
</script>
